import { Constants } from './../billing-page/billing-page.types';
import { Component, ChangeDetectorRef } from '@angular/core';
import { DatasetOption } from '@dxo/ng-swift-ui';
import { environment } from '@benefitsui/environments/environment';
import { UserContextService } from '../../services/user-context/user-context.service';
import { UserContext } from '../../services/user-context/user-context.types';
import { AuthenticationService } from '@benefitsui/app/services/auth/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FlagsService } from '@benefitsui/app/services/flags/flags.service';
import { FlatRouteEntry } from '@dxo/ng-swift-ui/lib/components/nav/components/side-nav/side-nav.types';
import { BehaviorSubject, Observable, combineLatest, map, of } from 'rxjs';
import { LeftNavMenu, TopRightMenuItem } from '@dxo/ng-swift-ui';
import { UserRole } from '@benefitsui/app/shared/enums/users';

@Component({
  selector: 'app-nav-portal-page',
  templateUrl: './left-nav-portal-page.component.html',
  styleUrls: ['./left-nav-portal-page.component.scss'],
  providers: [UserContextService]
})
export class LeftNavPortalPageComponent {
  //constants
  LogOut = 'Log off';
  ProfileSettings = 'Profile Settings';
  PartnerPortal = 'Partner Portal';
  PartnerPortalUrl = environment.partnerPortalUrl;
  ProfileSettingsUrl = environment.profileSettingsUrl;
  constructor(
    private authService: AuthenticationService,
    private userContextService: UserContextService,
    private router: Router,
    private flagsService: FlagsService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.userContext = this.userContextService.get();
    this.userFullName = this.userContext.currentUserFullName;
    this.userType = this.userContext.symClass;
    switch (this.userContext.symClass.toLowerCase()) {
      case 'employee':
        this.userRole = UserRole.Employee;
        break;
      case 'distributor':
        this.userRole = UserRole.Broker;
        break;
      case 'sponsor':
        this.userRole = UserRole.Sponsor;
        break;
      default:
        this.userRole = UserRole.Sponsor;
        break;
    }
    this.logoText = 'benefits';

    this.topRightMenuEmployee = [
      {
        label: this.LogOut,
        icon: {
          name: 'lock'
        },
        onClick: () => this.logout()
      }
    ];

    this.topRightMenuPolicy = [
      {
        label: this.ProfileSettings,
        icon: {
          name: ''
        },
        onClick: () => this.goProfileSettings()
      },
      {
        label: this.LogOut,
        icon: {
          name: 'lock'
        },
        onClick: () => this.logout()
      }
    ];

    this.topRightMenuBroker = [
      {
        label: this.PartnerPortal,
        icon: {
          name: ''
        },
        onClick: () => this.goPartnerPortal()
      },
      {
        label: this.ProfileSettings,
        icon: {
          name: ''
        },
        onClick: () => this.goProfileSettings()
      },
      {
        label: this.LogOut,
        icon: {
          name: 'lock'
        },
        onClick: () => this.logout()
      }
    ];

    switch (this.userType.toLowerCase()) {
      case UserRole.Employee:
        this.topRightMenu = this.topRightMenuEmployee;
        break;
      case UserRole.Broker:
        this.topRightMenu = this.topRightMenuBroker;
        break;
      case UserRole.Sponsor:
        this.topRightMenu = this.topRightMenuPolicy;
        break;
      default:
        this.topRightMenu = this.topRightMenuEmployee;
        break;
    }

    this.topRightMenu.filter((x) => !!x) as TopRightMenuItem[];
  }

  ngOnInit() {
    this.initializeFlags();
    this.setLeftNavMenu();
    this.cdr.detectChanges();
  }

  initializeFlags() {
    this.isAdmin.next(this.userContext.policyholderInfo?.isAdmin ?? false);
    this.isBasic.next(this.userContext.symEmployeeInfo?.isBasic ?? false);
    this.hasListBill = this.flagsService.subscribeToFlag('HASLISTBILL');
    this.showBilling = this.flagsService.subscribeToFlag('SHOW_BILLINGS');
    this.showClaim = this.flagsService.subscribeToFlag('SHOW_CLAIMS');
    this.showDocuments = this.flagsService.subscribeToFlag('SHOW_DOCUMENTS');
    this.showEOI = this.flagsService.subscribeToFlag('SHOW_EOI');
    this.showInsured = this.flagsService.subscribeToFlag('SHOW_INSURED');
    this.showScheduleA = this.flagsService.subscribeToFlag('SHOW_SCHEDULEA');
    this.showManageInsured = combineLatest([
      this.showInsured,
      this.hasListBill
    ]).pipe(
      map(
        ([showInsured, hasListBill]: [boolean, boolean]) =>
          showInsured && hasListBill
      )
    );

    switch (this.userType.toLowerCase()) {
      case UserRole.Sponsor:
        this.showEmployeePages = combineLatest([
          this.isAdmin,
          this.hasListBill
        ]).pipe(
          map(
            ([isAdmin, hasListBill]: [boolean, boolean]) =>
              isAdmin && hasListBill
          )
        );
        this.showEmployeeTab = combineLatest([
          this.showEOI,
          this.showEmployeePages
        ]).pipe(
          map(([showEOI, showEmployeePages]) => showEOI || showEmployeePages)
        );
        break;

      case UserRole.Broker:
        this.showEmployeePages = this.hasListBill;
        this.showEmployeeTab = new BehaviorSubject<boolean>(true);
        break;

      case UserRole.Employee:
        this.showEmployeePages = combineLatest([
          this.isBasic,
          this.hasListBill
        ]).pipe(
          map(
            ([isBasic, hasListBill]: [boolean, boolean]) =>
              isBasic && hasListBill
          )
        );
        this.showEmployeeTab = this.isBasic;
        break;

      default:
        this.showEmployeePages = new BehaviorSubject<boolean>(false);
    }
  }

  // :  Data members
  hasListBill = new BehaviorSubject<boolean>(false);
  showBilling = new BehaviorSubject<boolean>(false);
  showClaim = new BehaviorSubject<boolean>(false);
  showDocuments = new BehaviorSubject<boolean>(false);
  showEOI = new BehaviorSubject<boolean>(false);
  showInsured = new BehaviorSubject<boolean>(false);
  showScheduleA = new BehaviorSubject<boolean>(false);
  isAdmin = new BehaviorSubject<boolean>(false);
  isBasic = new BehaviorSubject<boolean>(false);
  showEmployeeTab!: Observable<boolean>;
  showEmployeePages!: Observable<boolean>;
  showManageInsured!: Observable<boolean>;
  policyToken = new BehaviorSubject<string>(Constants.StringEmpty);
  menu?: LeftNavMenu;
  topRightMenu: TopRightMenuItem[] = [];
  topRightMenuPolicy: TopRightMenuItem[] = [];
  topRightMenuBroker: TopRightMenuItem[] = [];
  topRightMenuEmployee: TopRightMenuItem[] = [];
  accountMenuItems: FlatRouteEntry[] = [];
  logoText: string;
  userContext: UserContext;
  userFullName: string;
  userType: string;
  userRole: UserRole;
  initialCountdown: number = environment.countdownSeconds;

  logoutDatasetData: DatasetOption['data'] = {
    name: 'Logout'
  };
  logoutDataset: DatasetOption[] = [
    { data: this.logoutDatasetData },
    { selector: 'span,div,dxo-icon', data: this.logoutDatasetData }
  ];

  logout() {
    this.authService.logout();
  }

  isBroker(): boolean {
    return this.userRole === UserRole.Broker;
  }

  isSponsor(): boolean {
    return this.userRole === UserRole.Sponsor;
  }
  isEmployee(): boolean {
    return this.userRole === UserRole.Employee;
  }

  goProfileSettings() {
    window.open(this.ProfileSettingsUrl);
  }

  goPartnerPortal() {
    window.location.href = this.PartnerPortalUrl;
  }

  setLeftNavMenu() {
    this.menu = {
      levelOne: [
        {
          label: 'Back to Groups',
          href: '/benefits/search',
          icon: 'arrow_back',
          visible$: of(this.isEmployee() || this.isBroker())
        },
        {
          label: 'Dashboard',
          icon: 'dashboard',
          routerLink: '/benefits/dashboard',
          queryParamsHandling: 'preserve'
        },
        {
          label: 'Financial',
          expanded: false,
          visible$: this.showBilling,
          levelTwo: [
            {
              label: 'Billing',
              routerLink: '/benefits/billing',
              queryParamsHandling: 'preserve'
            },
            {
              label: 'Tax Forms',
              routerLink: '/benefits/financial/tax',
              queryParamsHandling: 'preserve'
            }
          ]
        },
        {
          label: 'Employees',
          expanded: false,
          visible$: this.showEmployeeTab,
          levelTwo: [
            {
              label: 'Search Employees',
              routerLink: '/benefits/employees',
              queryParamsHandling: 'preserve',
              visible$: this.showEmployeePages
            },
            {
              label: 'Add Employee',
              routerLink: '/benefits/employees/add',
              queryParamsHandling: 'preserve',
              visible$: this.showEmployeePages
            },
            {
              label: 'EOI Report',
              routerLink: '/benefits/report',
              queryParamsHandling: 'preserve',
              visible$: this.showEOI
            }
          ]
        },
        {
          label: 'Claims',
          expanded: false,
          visible$: this.showClaim,
          levelTwo: [
            {
              label: 'Search Claims',
              routerLink: '/benefits/claims/search',
              queryParamsHandling: 'preserve'
            },
            {
              label: 'Create New Claim',
              routerLink: '/benefits/claims/create',
              queryParamsHandling: 'preserve'
            }
          ]
        },
        {
          label: 'Resources',
          expanded: true,
          levelTwo: [
            {
              label: 'Contract Documents',
              routerLink: '/benefits/documents',
              queryParamsHandling: 'preserve'
            },
            {
              label: 'All Forms',
              routerLink: '/benefits/allforms',
              queryParamsHandling: 'preserve',
              routerLinkActiveOptions: {
                matrixParams: 'exact',
                queryParams: 'ignored',
                paths: 'subset',
                fragment: 'ignored'
              }
            }
          ]
        }
      ]
    };
  }
}
